module.exports = __webpack_public_path__ + "static/media/sports-south.0ea34b11.jpg";